export default __webpack_public_path__ + "static/media/icon-plugin.71a63cd1.svg";